var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"warning--text"},[_vm._v("Gmailの送信画面へ移ります")]),_c('VBtn',{attrs:{"color":"primary"},on:{"click":_vm.send}},[_vm._v("質問メールの送信へ移る")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }